import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function StepContact({ form, setForm }) {
  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  return (
    <div>
      <h2
        className="text-2xl sm:text-3xl font-bold tracking-tight mb-2"
        style={{ fontFamily: "'Clash Display', sans-serif" }}
      >
        Your Details
      </h2>
      <p className="text-sm text-[#A3A3A3] mb-8">Where should we send your quote?</p>

      <div className="space-y-6 max-w-2xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <Label htmlFor="q-name" className="text-sm font-medium text-[#A3A3A3] mb-2 block">Full Name *</Label>
            <Input
              id="q-name"
              name="name"
              data-testid="quote-name-input"
              value={form.name}
              onChange={handleChange}
              required
              placeholder="John Smith"
              className="bg-[#1F1F1F] border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none h-12"
            />
          </div>
          <div>
            <Label htmlFor="q-company" className="text-sm font-medium text-[#A3A3A3] mb-2 block">Company</Label>
            <Input
              id="q-company"
              name="company"
              data-testid="quote-company-input"
              value={form.company}
              onChange={handleChange}
              placeholder="Your Company Pty Ltd"
              className="bg-[#1F1F1F] border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none h-12"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <Label htmlFor="q-email" className="text-sm font-medium text-[#A3A3A3] mb-2 block">Email Address *</Label>
            <Input
              id="q-email"
              name="email"
              type="email"
              data-testid="quote-email-input"
              value={form.email}
              onChange={handleChange}
              required
              placeholder="john@company.com.au"
              className="bg-[#1F1F1F] border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none h-12"
            />
          </div>
          <div>
            <Label htmlFor="q-phone" className="text-sm font-medium text-[#A3A3A3] mb-2 block">Phone</Label>
            <Input
              id="q-phone"
              name="phone"
              type="tel"
              data-testid="quote-phone-input"
              value={form.phone}
              onChange={handleChange}
              placeholder="(08) 9XXX XXXX"
              className="bg-[#1F1F1F] border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none h-12"
            />
          </div>
        </div>
        <div>
          <Label htmlFor="q-notes" className="text-sm font-medium text-[#A3A3A3] mb-2 block">Special Notes</Label>
          <textarea
            id="q-notes"
            name="notes"
            data-testid="quote-notes-input"
            value={form.notes}
            onChange={handleChange}
            rows={4}
            placeholder="Any additional details, special requirements, or questions..."
            className="w-full bg-[#1F1F1F] border border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none p-3 text-sm resize-none outline-none"
          />
        </div>
      </div>
    </div>
  );
}
